import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import actions from './actions';
import {deleto, get, patch, post, puto} from 'bukku/shared/ApiService';
import {errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn} from "../helper";
import {t} from "@lingui/macro";

const successKeys = [
    actions.PAYMENT_METHOD_CREATE_SUCCESS,
    actions.PAYMENT_METHOD_CREATE_SUCCESS,
    actions.PAYMENT_METHOD_READ_SUCCESS,
    actions.PAYMENT_METHOD_READ_ALL_SUCCESS,
    actions.PAYMENT_METHOD_UPDATE_SUCCESS,
    actions.PAYMENT_METHOD_ARCHIVE_SUCCESS,
    actions.PAYMENT_METHOD_DELETE_SUCCESS,
];
const errorKeys = [
    actions.PAYMENT_METHOD_CREATE_ERROR,
    actions.PAYMENT_METHOD_CREATE_ERROR,
    actions.PAYMENT_METHOD_READ_ERROR,
    actions.PAYMENT_METHOD_READ_ALL_ERROR,
    actions.PAYMENT_METHOD_UPDATE_ERROR,
    actions.PAYMENT_METHOD_ARCHIVE_ERROR,
    actions.PAYMENT_METHOD_DELETE_ERROR,
];

const getSuccessMsg = action => {
    switch (action.type) {
        case actions.PAYMENT_METHOD_CREATE_SUCCESS:
            return t`The payment method is created.`;
        case actions.PAYMENT_METHOD_UPDATE_SUCCESS:
            return t`The payment method is updated.`;
        case actions.PAYMENT_METHOD_DELETE_SUCCESS:
            return t`The payment method is deleted.`;
        default:
            return null;
    }
};

// Create payment method
function* createPaymentMethodRequest() {
    yield takeEvery(actions.PAYMENT_METHOD_CREATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ request }) {
                const response = yield call(post, '/payment_methods', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PAYMENT_METHOD_CREATE_SUCCESS,
                    paymentMethod: data.payment_method,
                });
            });
    });
}

// Read payment method list
function* readPaymentMethodsRequest() {
    yield takeEvery(actions.PAYMENT_METHOD_READ_ALL_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ request }) {
                const response = yield call(get, '/payment_methods', request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PAYMENT_METHOD_READ_ALL_SUCCESS,
                    paymentMethods: data.payment_methods,
                    pagination: data.paging,
                });
            });
    });
}

// Read payment method (by id)
function* readPaymentMethodRequest() {
    yield takeEvery(actions.PAYMENT_METHOD_READ_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* ({ id }) {
                const response = yield call(get, `/payment_methods/${id}`, null, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PAYMENT_METHOD_READ_SUCCESS,
                    paymentMethod: data.payment_method,
                });
            });
    });
}

// Update payment method (by id)
function* updatePaymentMethodRequest() {
    yield takeEvery(actions.PAYMENT_METHOD_UPDATE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                const response = yield call(puto, `/payment_methods/${id}`, request, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.PAYMENT_METHOD_UPDATE_SUCCESS,
                    paymentMethod: data.payment_methods,
                });
            });
    });
}

// Archive payment method (by id)
function* archivePaymentMethodRequest() {
    yield takeEvery(actions.PAYMENT_METHOD_ARCHIVE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id, request }) {
                yield call(patch, `/payment_methods/${id}`, request, context);

                // OK
                yield put({
                    type: actions.PAYMENT_METHOD_ARCHIVE_SUCCESS,
                });
            });
    });
}

// Archive payment method (by id)
function* deletePaymentMethodRequest() {
    yield takeEvery(actions.PAYMENT_METHOD_DELETE_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ id }) {
                yield call(deleto, `/payment_methods/${id}`, null, context);
                yield put({ type: actions.PAYMENT_METHOD_DELETE_SUCCESS });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),
        fork(createPaymentMethodRequest),
        fork(readPaymentMethodsRequest),
        fork(readPaymentMethodRequest),
        fork(updatePaymentMethodRequest),
        fork(archivePaymentMethodRequest),
        fork(deletePaymentMethodRequest),
    ]);
}
